import { Button, Grid } from '@mui/material';
import { styles } from './styles';

export const DraftDialogFooter = ({ onCancel }: { onCancel: () => void }) => {
  return (
    <Grid sx={styles.cancelButtonContainer}>
      <Button sx={styles.cancelButton} onClick={onCancel}>
        Cancel
      </Button>
    </Grid>
  );
};
